
import { Component, Mixins } from "vue-property-decorator";

@Component
export default class ObjectUpdatesPromptableMixin extends Mixins() {
  promptForObjectUpdates(event: PointerEvent): void {
    if (document.activeElement instanceof HTMLElement) {
      // プロパティ入力中に選択外れると入力中の値が反映されない...先にblur()して値を確定させる.
      document.activeElement.blur();
      if (event.target instanceof HTMLElement) {
        // IEの場合、blur()でbodyにフォーカスが移動した後、再度blur()を呼んでも値を確定できないためあらかじめフォーカスをセットしておく
        // 上記のblur()を外してfocus()のみにするとChromeで値を確定できないため外さない
        event.target.focus();
      }
    }
  }
}
